import ScreenWrapper from "@/components/ScreenWrapper"
import { createFileRoute } from "@tanstack/react-router"
import { checkPermissions } from "@/utils/checkPermissions"
import { GroupFormStepper } from "@/components/forms/groups/GroupFormStepper"
import { GroupFormStepperScoped } from "@/components/forms/groups/GroupFormStepperDefinition"
import { useGroupCreateStore } from "@/stores/useGroupCreateStore"

export const Route = createFileRoute("/beheer/groepen/aanmaken")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("create", "groups"),
})

function RouteComponent() {
  const { lessonGroup } = useGroupCreateStore()

  const initialStep = () => {
    if (!lessonGroup) {
      return "info"
    } else if (
      !lessonGroup.lessonGroupLocations ||
      lessonGroup.lessonGroupLocations.length === 0
    ) {
      return "location"
    }

    return "members"
  }

  return (
    <ScreenWrapper>
      <section className="calculated-height">
        <GroupFormStepperScoped initialStep={initialStep()}>
          <GroupFormStepper />
        </GroupFormStepperScoped>
      </section>
    </ScreenWrapper>
  )
}
